import dbServices from "./db"
import { sendWelcomeMail } from "../mail"
import { userModel, userProfileModel } from "./Models"
import { getFromStorage, setToStorage } from "../utils"
import {
  getAuth,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  updateProfile,
  updatePassword,
  reauthenticateWithCredential,
  EmailAuthProvider,
  sendEmailsVerificationLink,
  applyActionCode,
} from "firebase/auth"

const validationURL = `${process.env.GATSBY_BASE_URL}/console/validation`

const actionCodeSettings = {
  // URL you want to redirect back to. The domain (www.example.com) for this
  // URL must be in the authorized domains list in the Firebase Console.
  url: validationURL,
  // This must be true.
  handleCodeInApp: true,
}
const auth = typeof window !== "undefined" ? getAuth() : {}

const signUp = async (username, email, plan = null, newPassword = null) => {
  try {
    const user = await createUserWithEmailAndPassword(auth, email, newPassword)

    if (user?.user) {
      await updateProfile(user?.user, {
        displayName: username,
      })

      const userData = Object.create(userModel)
      userData.constructUser(user?.user)
      const profile = Object.create(userProfileModel)
      const today = new Date()
      const dd = String(today.getDate()).padStart(2, "0")
      const mm = String(today.getMonth() + 1).padStart(2, "0") //January is 0!
      const yyyy = today.getFullYear()

      const fortnightAway = new Date(Date.now() + 12096e5)
      const fortnightAwaydd = String(fortnightAway.getDate()).padStart(2, "0")
      const fortnightAwaymm = String(fortnightAway.getMonth() + 1).padStart(
        2,
        "0"
      ) //January is 0!
      const fortnightAwayyyyy = fortnightAway.getFullYear()

      const purchaseDate = dd + "/" + mm + "/" + yyyy

      const experationDate =
        fortnightAwaydd + "/" + fortnightAwaymm + "/" + fortnightAwayyyyy
      const data = {
        id: email,
        plan,
        users: [],
        purchases: [],
        purchasesHistory: {
          [`Register-${today}`]: {
            experationDate: experationDate,
            purchaseDate: purchaseDate,
            usersNumber: 2,
          },
        },
        freeUsers: 2,
      }
      profile.constructProfile(data, userData)
      profile.generateLicenceKey()

      await dbServices.addUSer(email, profile)

      return { success: true, error: null, message: null }
    }
  } catch (error) {
    console.error("error ", error)
    return { success: false, error, message: error.code }
  }
}

const signIn = async (email, password) => {
  try {
    const user = await signInWithEmailAndPassword(auth, email, password)
    if (user?.user?.emailVerified) {
      const userData = Object.create(userModel)
      userData.constructUser(user?.user)
      const profile = Object.create(userProfileModel)

      const dbData = await dbServices.getUSer(email)

      if (dbData.welcomeEmailNotSent) {
        // send mail
        await sendWelcomeMail(email)
        await dbServices.editUSer(email, {
          welcomeEmailNotSent: false,
        })
      }
      profile.constructProfile(dbData, userData)
      setToStorage("profile", profile)
      setToStorage("user", JSON.stringify(userData))
      return {
        success: true,
        error: null,
        isAdmin: dbData.admin,
        message: null,
      }
    } else
      return {
        success: false,
        error: null,
        message: "This Email address is not verified",
      }
  } catch (error) {
    return { success: false, error, message: "Oups: Wrong credentials!" }
  }
}

const validateAccount = async link => {
  // if (isSignInWithEmailLink(auth, link)) {
  // Additional state parameters can also be passed via URL.
  // This can be used to continue the user's intended action before triggering
  // the sign-in operation.
  // Get the email if available. This should be available if the user completes
  // the flow on the same device where they started it.
  // let email = window.localStorage.getItem('emailForSignIn');
  // if (!email) {
  // User opened the link on a different device. To prevent session fixation
  // attacks, ask the user to provide the associated email again. For example:
  //email = window.prompt('Please provide your email for confirmation');
  // }
  // The client SDK will parse the code from the link for you.
  // const user = await signInWithEmailLink(auth, email, link)
  try {
    const oobCode = link
      .split("&")
      .find(e => e.includes("oobCode="))
      .replace("oobCode=", "")
    await applyActionCode(auth, oobCode)
    return { success: true, error: null, message: null }
  } catch (error) {
    return { success: false, error, message: "Error validating the account" }
  }
  // const user = await applyActionCode(auth, link)
  // .then((result) => {
  //   // Clear email from storage.
  //   window.localStorage.removeItem('emailForSignIn');
  //   // You can access the new user via result.user
  //   // Additional user info profile not available via:
  //   // result.additionalUserInfo.profile == null
  //   // You can check if the user is new or existing:
  //   // result.additionalUserInfo.isNewUser
  // })
  // .catch((error) => {
  //   // Some error occurred, you can inspect the code: error.code
  //   // Common errors could be invalid email and invalid or expired OTPs.
  // });
  // } else {
  //   throw "the link is invalid"
  // }
}

const logOut = async () => {
  localStorage.clear()
}

const setPassword = async (newPassword, oldPassword) => {
  let response = { success: true, error: null, message: null }

  try {
    if (oldPassword) {
      const credential = EmailAuthProvider.credential(
        auth.currentUser.email,
        oldPassword
      )
      await reauthenticateWithCredential(auth.currentUser, credential)
    }
    await updatePassword(auth.currentUser, newPassword)
  } catch (error) {
    response.success = false
    response.error = error
    response.message =
      oldPassword && error.code?.includes("wrong-password")
        ? "Invalid current password"
        : "Error while updating the password"
  }
  return response
}

const updateAccountName = async userInfos => {
  let response = {
    success: false,
    error: "userInfos is undifined",
    message: "Error while updating your profile",
  }

  if (userInfos) {
    try {
      await updateProfile(auth.currentUser, userInfos)

      const localUserData = JSON.parse(getFromStorage("user"))
      setToStorage("user", { ...localUserData, ...userInfos })

      response.success = true
      response.error = null
      response.message = { user: { ...localUserData, ...userInfos } }
    } catch (error) {
      response.success = false
      response.error = error
      response.message = "Error while updating your profile"
    }
  }

  return response
}

const resendVerificationLink = (extra = "noExtra") => {
  const theURL = {
    url: `${validationURL}/${auth.currentUser.email}/${extra}/`,
  }
  sendEmailsVerificationLink(auth.currentUser, {
    ...actionCodeSettings,
    ...theURL,
  }).catch(error => {
    console.error("resend Verification Link error:", error)
  })
}
const authentication = {
  auth,
  signUp,
  signIn,
  validateAccount,
  logOut,
  setPassword,
  updateAccountName,
  resendVerificationLink,
}
export default authentication
